import s from './Avatar.module.sass'

import * as React from 'react'
import { useState, useEffect, memo } from 'react'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import IconAfisha from '@icons/icon-badge-afisha.svg'

import { getPlaceholderImage } from '@shared/lib/helpers/getPlaceholderImage'
import { Title } from '@shared/ui/Typography/Title'
// @ts-ignore
import { ErrorBoundary } from '../../../lib/components/ErrorBoundary'
import { AvatarSkeleton } from '@shared/ui/Media/Avatar/index'

// type size = 'S M L XL'

interface Props {
  sizes: string
  src: string
  alt?: string
  afisha?: boolean
  className?: string
  userName: string
}

const randomNum = (min = 0, max: number) => Math.floor(Math.random() * (max - min + 1)) + min

// Проверка что фотография загрузилась
function getImage(url: string): Promise<string | null> {
  return new Promise(function (resolve, reject) {
    const img = new Image()
    img.onload = () => resolve(url)
    img.onerror = () => reject(url)
    img.src = url
  })
    .then((url) => url as string)
    .catch(() => null)
}

const Avatar = ({
  sizes,
  src,
  afisha = false,
  alt = 'avatar image',
  userName = 'Рик Эстли',
  className = '',
  ...props
}: Props & React.HTMLAttributes<HTMLDivElement>): React.ReactElement => {
  const [avatar, setAvatar] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [size] = useCurrentSize(sizes)

  // Проверка что фотография загрузилась
  useEffect(() => {
    getImage(src)
      .then((src) => setAvatar(src))
      .finally(() => setLoading(false))
  }, [src])

  const generatedIdFromName = userName.length > 0 ? userName[randomNum(0, userName.length - 1)]?.charCodeAt(0) : 0

  return (
    <ErrorBoundary>
      {!loading ? (
        <div className={`${s.avatar} ${className}`} data-size={size} data-has-afisha-review={afisha} {...props}>
          {avatar ? (
            // @ts-ignore
            <img
              className={s.img}
              src={avatar}
              alt={alt}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <div
              className={s['img-default']}
              style={{ backgroundImage: `url(${getPlaceholderImage(generatedIdFromName, 'bg')})` }}>
              <Title sizes={'h5'} className={s['first-letter']}>
                {userName[0]}
              </Title>
            </div>
          )}

          {afisha && <IconAfisha className={s.afisha} />}
        </div>
      ) : (
        <AvatarSkeleton sizes={sizes} className={className} />
      )}
    </ErrorBoundary>
  )
}

export default memo(Avatar)
